import { createReducer } from "@reduxjs/toolkit";
import {
  APPS_TYPES_ERROR,
  APPS_TYPES_LIST,
  APPS_TYPES_LOADING,
  CREATE_APPS_TYPES,
  DELETE_APPS_TYPES,
  EDIT_APPS_TYPES,
} from "../actions/types";

const initialState = {
  error: "",
  loading: false,
  data: [],
};

const appsTypesReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(APPS_TYPES_LOADING, (state) => {
      state.loading = true;
    })
    .addCase(APPS_TYPES_ERROR, (state, { payload }) => {
      state.error = payload;
      state.loading = false;
    })
    .addCase(APPS_TYPES_LIST, (state, { payload }) => {
      state.data = payload;
      state.loading = false;
    })
    .addCase(CREATE_APPS_TYPES, (state, { payload }) => {
      Array.isArray(state.data)
        ? state.data.push(payload)
        : (state.data = [payload]);
      state.loading = false;
    })
    .addCase(EDIT_APPS_TYPES, (state, { payload }) => {
      const index = state.data.findIndex((e) => e?.id === payload?.id);
      state.data[index] = payload;
      state.loading = false;
    })
    .addCase(DELETE_APPS_TYPES, (state, { payload }) => {
      state.data = state.data.filter((e) => e?.id !== payload?.id);
      state.loading = false;
    });
});

export default appsTypesReducer;
